module.exports = __webpack_public_path__ + "img/outshinery-logo.2e0546b6.png";